export default __webpack_public_path__ + "static/media/8.251c9031.jpg";